import { Injectable } from "@angular/core";

declare var fbq: Function;

@Injectable({
    providedIn: 'root'
})
export class MetaPixelService {
    // Sign In & Sign Up Events 
    public onSignInEvent(event) {
        fbq('trackCustom', 'Sign In', {
            // user_email: event
        });
    }

    public onSignUpEvent(event) {
        fbq('trackCustom', 'Sign Up', {
            // user_email: event
        });
    }
    public onHostSignUpEvent(event) {
        fbq('trackCustom', 'Host Sign Up', {
            // host_email: event
        });
    }
    // Sign In & Sign Up Events 
    // Verification
    public onSMSVerificationEvent(event) {
        fbq('trackCustom', 'SMS Verification', {
            // user_email: event
        })
    }
    public onEmailVerificationEvent(event) {
        fbq('trackCustom', 'Email Verification', {
            // user_email: event
        })
    }
    // Verification

    // Pricing Calculation
    public onPricingCalculation(event) {
        fbq('trackCustom', 'Shipping Price Calculation', {
            country_from: event.country_from,
            country_to: event.country_to,
            // user_email: event.user_email ? event.user_email : 'User Not Logged In'
        })
    }
    // Pricing Calculation
    // Package Order Events 
    public onGetAddressSuccessEvent(event) {
        fbq('trackCustom', 'Get Address Success', {
            country_from: event.country_from,
            country_to: event.country_to,
            country_from_name: event.country_from_name,
            country_to_name: event.country_to_name,
            // shopper_email: event.shopper_email,
            invoice_expected_amount: event.invoice_expected_amount,
            dimension_expected_weight: event.dimension_expected_weight,
            dimension_expected_weight_unit: event.dimension_expected_weight_unit,
            product_link: event.product_link
        });
    }
    public onOrderPaymentStepOne(event) {

        fbq('trackCustom', 'Package Order Confirmation - Order Contents', {
            order_id: event.order_id,
            country_from: event.country_from,
            country_from_name: event.country_from_name,
            country_to: event.country_to,
            country_to_name: event.country_to_name,
            product_link: event.product_link,
            invoice_actual_amount: event.invoice_actual_amount,
            dimension_actual_weight: event.dimension_actual_weight,
            dimension_actual_weight_unit: event.dimension_actual_weight_unit
        })
    }
    public onOrderPaymentStepTwo(event) {
        fbq('trackCustom', 'Package Order Confirmation - Address Selection', {
            order_id: event.order_id,
            country_from: event.country_from,
            country_from_name: event.country_from_name,
            country_to: event.country_to,
            country_to_name: event.country_to_name,
            product_link: event.product_link,
            invoice_actual_amount: event.invoice_actual_amount,
            dimension_actual_weight: event.dimension_actual_weight,
            dimension_actual_weight_unit: event.dimension_actual_weight_unit
        })
    }
    public onOrderSuccessEvent(event) {
        fbq('trackCustom', 'Order Success', {
            order_id: event.order_id,
            country_from: event.country_from,
            country_from_name: event.country_from_name,
            country_to: event.country_to,
            country_to_name: event.country_to_name,
            product_link: event.product_link,
            invoice_actual_amount: event.invoice_actual_amount,
            dimension_actual_weight: event.dimension_actual_weight,
            dimension_actual_weight_unit: event.dimension_actual_weight_unit,
            amount: event.amount,
            // shopper_email: event.shopper_email
        });
    }
    // Package Order Events 

    // BFM Events
    public onBFMCheckoutEvent(event) {
        fbq('trackCustom', 'BFM Checkout', {
            country_from: event.country_from,
            country_to: event.country_to,
            bfm_items: event.items,
            shopper: event.shopper_id,
            // shopper_email: event.shopper_email
        });
    }
    public onBFMSuccessEvent(event) {
        fbq('trackCustom', 'BFM Order Success', {
            country_from: event.country_from,
            country_from_name: event.country_from_name,
            country_to: event.country_to,
            country_to_name: event.country_to_name,
            bfm_items: event.items,
            bfm_total: event.bfm_total,
            bfm_currency: event.bfm_currency,
            // shopper_email: event.email
        });
    }
    // BFM Events 
    public onBFMExtraChargeSuccess(event){
        fbq('trackCustom', 'BFM Extra Charge Success', {
            country_from: event.country_from,
            country_from_name: event.country_from_name,
            country_to: event.country_to,
            country_to_name: event.country_to_name,
            bfm_items: event.items,
            bfm_total: event.bfm_total,
            bfm_currency: event.bfm_currency,
            // shopper_email: event.email
        });
    }
}